import { useState, type Dispatch, type SetStateAction } from 'react';
import { useEacSettings } from '@/contexts/EacSettingsContext';
import type { EacMethod } from '@/lib/utils';

export interface ForecastEacSettings {
  eacMethod: EacMethod;
  showHoursToComplete: boolean;
  /** Whether the PM has submitted Hours to Complete data */
  htcAvailable: boolean;
  setHtcAvailable: Dispatch<SetStateAction<boolean>>;
}

/**
 * Company-wide EAC settings together with HTC availability, which is a separate
 * concept kept as local state until the data-service layer provides it.
 */
export function useForecastEacSettings(): ForecastEacSettings {
  const { eacMethod, showHoursToComplete } = useEacSettings();
  const [htcAvailable, setHtcAvailable] = useState(false);

  return { eacMethod, showHoursToComplete, htcAvailable, setHtcAvailable };
}
